export const MediaPlanInitialState = {
    campaignBrief: { rating: 2, comment: '' },
    competitionAndMedia: { rating: 2, comment: '' },
    systemRecommendation: { rating: 3, comment: '' },
    plannerRecommendation: { rating: 2, comment: '' }
};
export const briefInitialState = {
    aboutBrand: { rating: 2, comment: '' },
    campaignDetails: { rating: 2, comment: '' },
    targetAudience: { rating: 2, comment: '' },
    mediaPreferences: { rating: 3, comment: '' },
    mediaSpecificDetails: { rating: 3, comment: '' }
};
